import { Contact, FooterMain, InstitutoLogo, Logo, Logos, Title, UnifespLogo } from "./FooterElements";

export default function Footer() {
  return (
    <FooterMain>
      <Logos>
        <Logo src="./images/HomePageLogo.png" />
        <Title>Fluxo de Vacinação</Title>
      </Logos>
      <Logos>
        <UnifespLogo src="./images/UnifespLogo.png" />
        <InstitutoLogo src="./images/IfmsLogo.png" />
      </Logos>
    </FooterMain>
  );
}